module.exports = __webpack_public_path__ + "static/media/iso.df031b0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/filetype/iso.png
// module id = 2559
// module chunks = 0